import ky from "ky";

import { PUBLIC_CORE_API_URL } from "./config";

type CoreApiOptions = {
  headers?: HeadersInit;
  redirectOnUnauthorized?: boolean;
};

const buildLoginRedirectUrl = () => {
  if (typeof window === "undefined") {
    return "/login";
  }

  const currentPath = `${window.location.pathname}${window.location.search}`;
  const safePath = currentPath.startsWith("/")
    ? currentPath
    : `/${currentPath}`;

  return `/login?redirect=${encodeURIComponent(safePath)}`;
};

const createCoreApi = ({
  headers,
  redirectOnUnauthorized = true,
}: CoreApiOptions = {}) =>
  ky.create({
    prefixUrl: PUBLIC_CORE_API_URL,
    credentials: "include",
    throwHttpErrors: false,
    headers,
    hooks: {
      afterResponse: [
        (_request, _options, response) => {
          if (
            redirectOnUnauthorized &&
            response.status === 401 &&
            typeof window !== "undefined" &&
            window.location.pathname !== "/login"
          ) {
            window.location.replace(buildLoginRedirectUrl());
          }

          return response;
        },
      ],
    },
  });

export const coreApi = createCoreApi();
